import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Code, HStack, Tooltip } from '@bonusly/design-system';

type FlagStatusProps = {
	flagName: string;
	isEnabled: boolean;
};

export const FlagStatus: FC<FlagStatusProps> = ({ flagName, isEnabled }) => {
	const { t } = useTranslation('labs');

	return (
		<HStack spacing={2} align="center">
			<Tooltip label={isEnabled ? t('flagStatus.on') : t('flagStatus.off')} placement="top">
				<Box
					w={3}
					h={3}
					borderRadius="full"
					bg={isEnabled ? 'success.icon' : 'text.softest'}
					boxShadow={isEnabled ? '0 0 0 3px var(--chakra-colors-points-bgAlpha)' : 'none'}
					aria-label={isEnabled ? t('flagStatus.on') : t('flagStatus.off')}
					data-testid={`flag-status-dot-${isEnabled ? 'on' : 'off'}`}
				/>
			</Tooltip>
			<Tooltip label={t('flagTooltip')} placement="top">
				<Code fontSize="xs" px={2} py={0.5} borderRadius="sm">
					{flagName}
				</Code>
			</Tooltip>
		</HStack>
	);
};
